import {connect} from 'react-redux';
import {AnimationSequence as Component} from './AnimationSequence';
import {
  showModal,
  incSolution,
  decSolution,
  setSolutionMixed,
  prepareGelBox,
  runGel,
  visualizeGel,
  loadDNALadder
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    solutions: state.notebook.protocolSection.scene.apparatus.solutions,
    tableData: state.notebook.protocolSection.tableData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    incSolution: (data) => {
      dispatch(incSolution(data))
    },
    decSolution: (data) => {
      dispatch(decSolution(data))
    },
    setSolutionMixed: (data) => {
      dispatch(setSolutionMixed(data))
    },
    prepareGelBox: (data) => {
      dispatch(prepareGelBox(data))
    },
    runGel: (data) => {
      dispatch(runGel(data))
    },
    visualizeGel: (data) => {
      dispatch(visualizeGel(data))
    },
    loadDNALadder: (data) => {
      dispatch(loadDNALadder(data))
    }
  };
}

export const AnimationSequence = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
